var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon-text"},[_c('i',{class:("icon-text__icon icon-" + _vm.iconName),attrs:{"aria-hidden":"true"}}),_c('span',{staticClass:"icon-text__title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }